document.addEventListener("DOMContentLoaded", function () {
  const sloganListItems = document.querySelectorAll(".service-slogan ul li");

  if (sloganListItems.length > 0) {
    // Ensure there are <li> elements
    sloganListItems.forEach((li, index) => {
      setTimeout(() => {
        const img = li.querySelector("img"); // Select the image inside the li
        if (img) {
          img.classList.add("underlined");
        }
      }, index * 2000); // Staggered effect
    });
  }
});
